import React from 'react';
import { ComponentUserRegisterProps } from '..';
import {
  ButtonContainer,
  ImageContainer,
  MainContainer,
  NextStepsButton,
  TextContainer,
} from './styles';
import approvedPayment from '../../../assets/approved-payment.svg';

export const ApprovedPayment: React.FC<ComponentUserRegisterProps> = ({
  nextPage,
}) => {
  return (
    <MainContainer>
      <h1>Pagamento aprovado!</h1>

      <ImageContainer>
        <img src={approvedPayment} alt="" />
      </ImageContainer>
      <TextContainer>
        <div>
          <span>
            Você receberá a confirmação do pagamento e as instruções dos
            próximos passos pelo e-mail informado.
          </span>
        </div>

        <div className="middleParagraph">
          <span>
            Caso não esteja na caixa de entrada, verifique a caixa de Spam.
          </span>
        </div>

        <div>
          Caso não tenha recebido o e-mail de confirmação, entre em contato
          conosco pelo e-mail{' '}
          <span className="emailText">cinco@inovahu.com</span>
        </div>
      </TextContainer>

      <ButtonContainer>
        <NextStepsButton
          isLoading={false}
          btnType="light"
          onClick={() => nextPage()}
        >
          Próximos passos
        </NextStepsButton>
      </ButtonContainer>
    </MainContainer>
  );
};
